export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", icon: "ri-footprint-line", description: "Trending sneakers, boots, and designer footwear" },
  { name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html", icon: "ri-t-shirt-line", description: "Premium hoodies and cozy sweaters" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html", icon: "ri-t-shirt-line", description: "Essential tees and graphic tops" },
  { name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html", icon: "ri-shirt-line", description: "Outerwear, bombers, and winter coats" },
  { name: "Pants / Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html", icon: "ri-pantone-line", description: "Jeans, trousers, and summer shorts" },
  { name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html", icon: "ri-glasses-line", description: "Caps, beanies, and trendy headwear" },
  { name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html", icon: "ri-stack-line", description: "Coordinated outfits and matching sets" },
  { name: "Underwear / Underpants", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html", icon: "ri-shirt-line", description: "Comfort essentials and basics" },
  { name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html", icon: "ri-football-line", description: "Sports jerseys and athletic wear" },
  { name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html", icon: "ri-star-line", description: "Watches, jewelry, and style accessories" },
  { name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html", icon: "ri-shopping-bag-line", description: "Backpacks, totes, and designer bags" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html", icon: "ri-link", description: "Leather belts and statement pieces" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html", icon: "ri-drop-line", description: "Fragrances and luxury scents" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html", icon: "ri-more-line", description: "More trending items and finds" },
];

export const testimonials = [
  { name: "Marcus Chen", email: "marcus@buyerpro.com", quote: "The mulebuy spreadsheet system completely changed how I compare products. Instead of jumping between sites, I get everything in one structured view. It saved me hours every week.", rating: 5 },
  { name: "Sophie Laurent", email: "sophie@fashionfwd.co", quote: "I was skeptical at first, but the mulebuy spreadsheet approach is genuinely the most efficient way to track prices and compare options across different platforms.", rating: 5 },
  { name: "James Wilson", email: "james@retailhub.io", quote: "As someone who sources products regularly, the mulebuy spreadsheet comparison method is a game-changer. Clear, structured, and incredibly time-saving.", rating: 5 },
];

export const comparisonData = [
  { feature: "Speed", mulebuy: "Fast structured comparison", traditional: "Slow manual search" },
  { feature: "Accuracy", mulebuy: "High – organized data", traditional: "Medium – scattered info" },
  { feature: "Convenience", mulebuy: "Centralized dashboard", traditional: "Fragmented sources" },
  { feature: "Price Tracking", mulebuy: "Automated updates", traditional: "Manual checking" },
  { feature: "Best For", mulebuy: "Smart frequent buyers", traditional: "Casual occasional browsing" },
];

export const statsData = [
  { value: "10K+", label: "Active Buyers" },
  { value: "14", label: "Categories Covered" },
  { value: "99%", label: "Satisfaction Rate" },
  { value: "24/7", label: "Data Updates" },
];

export const allArticles = [
  {
    label: "Editor's Pick",
    title: "Mulebuy Spreadsheet Complete Guide 2026",
    date: "June 20, 2026",
    path: "/mulebuy-spreadsheet-complete-guide",
    excerpt: "Everything you need to know about the mulebuy spreadsheet system — how it works, why it matters, and how to get started with structured product comparison.",
  },
  {
    label: "Comparison",
    title: "Mulebuy Spreadsheet vs Traditional Shopping Methods",
    date: "June 19, 2026",
    path: "/mulebuy-spreadsheet-comparison",
    excerpt: "A detailed side-by-side analysis of spreadsheet-based buying versus conventional browsing approaches for international shoppers.",
  },
  {
    label: "Beginner",
    title: "How to Start Using Mulebuy Spreadsheet Today",
    date: "June 18, 2026",
    path: "/mulebuy-spreadsheet-beginners",
    excerpt: "A beginner-friendly walkthrough of the mulebuy spreadsheet ecosystem — learn the basics and navigate your first product comparison in minutes.",
  },
  {
    label: "Tips",
    title: "10 Pro Mulebuy Spreadsheet Tips for Smart Buyers",
    date: "June 17, 2026",
    path: "/mulebuy-spreadsheet-complete-guide",
    excerpt: "Expert tips and best practices for maximizing your efficiency with the mulebuy spreadsheet comparison and price tracking system.",
  },
  {
    label: "Trending",
    title: "Why Mulebuy Spreadsheet Is Trending Among International Buyers",
    date: "June 16, 2026",
    path: "/mulebuy-spreadsheet-comparison",
    excerpt: "Explore the reasons behind the rapid rise of mulebuy spreadsheet adoption in the global shopping community and what it means for you.",
  },
  {
    label: "Guide",
    title: "Understanding Mulebuy Spreadsheet Data and Pricing",
    date: "June 15, 2026",
    path: "/mulebuy-spreadsheet-complete-guide",
    excerpt: "Deep dive into how the mulebuy spreadsheet organizes pricing information, shipping estimates, and platform reliability scores.",
  },
  {
    label: "Safety",
    title: "Is Mulebuy Spreadsheet Safe? Complete Safety Review",
    date: "June 14, 2026",
    path: "/mulebuy-spreadsheet-beginners",
    excerpt: "Honest safety assessment of the mulebuy spreadsheet ecosystem — what you need to know before using comparison platforms.",
  },
  {
    label: "Analysis",
    title: "Mulebuy Spreadsheet Category Breakdown by Product Type",
    date: "June 13, 2026",
    path: "/mulebuy-spreadsheet-comparison",
    excerpt: "How the mulebuy spreadsheet handles different product categories — from shoes and hoodies to accessories and bags.",
  },
  {
    label: "News",
    title: "Mulebuy Spreadsheet Updates and What's New in 2026",
    date: "June 12, 2026",
    path: "/mulebuy-spreadsheet-complete-guide",
    excerpt: "Stay updated with the latest mulebuy spreadsheet features, improvements, and community insights for this year.",
  },
];